import { CSSTransition } from 'react-transition-group'
import styled from 'styled-components'

export const StyledCSSTransition = styled(CSSTransition)`
  position: absolute;
  width: 100vw;
  height: 100vh;
  transition:
    opacity ${({ timeout }) => timeout}ms ease-in-out,
    transform ${({ timeout }) => timeout}ms ease-in-out;

  // Transition animations
  /* starting ENTER animation */
  &.screen-transition-enter {
    opacity: 0;
    transform: scale(1.05);
  }

  /* ending ENTER animation */
  &.screen-transition-enter-active,
  &.screen-transition-enter-done {
    opacity: 1;
    transform: scale(1);
  }

  /* starting EXIT animation */
  &.screen-transition-exit {
    opacity: 1;
    transform: scale(1);
  }

  /* ending EXIT animation */
  &.screen-transition-exit-active {
    opacity: 0;
    transform: scale(1.05);
  }
`
